export default "__VITE_ASSET__BsELGowl__"